<template>
  <z-popup v-model="PopupReturnShow" position="bottom">
    <div class="detail-activity-popup">
      <h4 class="detail-activity-popup-title flex-center">
        保障升级·售后无忧
        <div class="detail-activity-popup-title-icon" @click="PopupReturnShow = false">
          <img src="../../img/pop-close.png" alt="" />
        </div>
      </h4>
      <div class="detail-activity-popup-content">
        <img
          v-if="afterSalesService.descBannerPic"
          v-lazy="$setPicSize(afterSalesService.descBannerPic, 686)"
        />
        <img
          v-if="afterSalesService.descInfoPic"
          v-lazy="$setPicSize(afterSalesService.descInfoPic, 686)"
        />
      </div>
    </div>
  </z-popup>
</template>

<script>
import { Popup } from '@zz-common/zz-ui'
import Vue from 'vue'
import { defineComponent, watch, computed, ref } from '@vue/composition-api'
Vue.use(Popup)

export default defineComponent({
  props: {
    dataInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  setup(props, ctx) {
    const { $legoSend } = ctx.root
    const PopupReturnShow = ref(false)
    watch(
      () => PopupReturnShow.value,
      (val) => {
        if (val) {
          $legoSend({
            pagetype: 'Areaexposure',
            actiontype: 'T2974',
            backup: {
              sectionId: 144
            }
          })
        }
      }
    )

    const afterSalesService = computed(() => {
      const afterSalesService = props.dataInfo.afterSalesService || {}
      return afterSalesService
    })

    return { PopupReturnShow, afterSalesService }
  }
})
</script>

<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
.detail-activity-popup {
  padding-top: 28px;

  &-title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
    margin-bottom: -5px;
    color: #000000;
    font-weight: 500;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 1;

    &-icon {
      position: absolute;
      top: 0;
      right: 0;
      width: 80px;
      height: 80px;
      img {
        width: 24px;
        margin-top: 28px;
        margin-left: 28px;
      }
    }
  }

  &-content {
    box-sizing: border-box;
    height: calc(80vh - 108px);
    padding: 24px 32px 0;
    overflow-y: scroll;
    img {
      width: 100%;
      margin-bottom: 40px;
    }
  }
  &-content::-webkit-scrollbar {
    display: none;
  }
}
</style>
